import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Drawer from 'components/atoms/Drawers/Drawer/Drawer';
import utils from 'helpers/utils';
import {darken} from 'polished';

const StyledMenuDrawer = styled(Drawer)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--menu-drawer-width': props.$width,
      '--menu-drawer-swipe-cursor': props.$swipeDisabled ? 'pointer' : 'grab',
      '--menu-drawer-swipe-pointer-events': props.$swipeDisabled ? 'all' : 'none'
    };

    return utils.styleProps(attr, vars);
  })`
  &.MenuDrawer {
    &-anchorTop, &-anchorBottom {
      width: auto;
      .MuiPaper-root {
        width: auto;
      }
    }
  }

  &.MenuDrawer > .MuiPaper-root {
    border-width: 0;
    width: ${props => utils.isDefined(props.$width) ? props.$css.$var('--menu-drawer-width', false) : null};
  }
  
  &.MenuDrawer-persistent {
    &:not(.MenuDrawer-open) > .MuiPaper-root {
      width: 0;
    }
  }

  .MenuDrawer {
    &-content {
      height: 100%;
      min-height: fit-content;
      padding: ${props => props.theme.spacing(2)} 0;

      display: flex;
      flex-direction: column;
      justify-content: space-between;

      gap: ${props => props.theme.layout('1sp')};
      
      position: relative;
    }
    
    &-buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${props => props.theme.layout('1sp')};

      .IconButton {
        width: ${props => props.theme.layout('5sp')};
        height: ${props => props.theme.layout('5sp')};
        font-size: ${props => props.theme.layout(20)};
      }
      
      &-middle {
        flex-grow: 1;
      }
    }
    
    &-logo {
      height: ${props => props.theme.layout('5sp')}; 
      margin-bottom: ${props => props.theme.layout('2sp')};
      
      .Icon, .Logo {
        height: 100%;
        width: 100%;
      }
    }
    
    &-avatar {
      align-self: center;
      width: ${props => props.theme.layout('5sp')};
      height: ${props => props.theme.layout('5sp')};
      font-size: ${props => props.theme.fontSize(15)};

      margin-bottom: ${props => props.theme.layout('2sp')};
    }

    &-swipe {
      position: absolute;
      visibility: visible;
      cursor: ${props => props.$css.$var('--menu-drawer-swipe-cursor', false)};
      pointer-events: ${props => props.$css.$var('--menu-drawer-swipe-pointer-events', false)};
      height: 100%;
      width: ${props => props.theme.layout('2.5sp')};
      right: -${props => props.theme.layout('2.5sp')};
      top: 0;
    }
    
    &-pull {
      position: absolute;
      height: ${props => props.theme.layout('6sp')};
      width: ${props => props.theme.layout('0.75sp')};
      top: calc(50% - (${props => props.theme.layout('6sp')} / 2));
      right: ${props => props.theme.layout('1.125sp')};
      background-color: ${props => darken(0.1, props.theme.property('palette.divider'))};
      border-radius: ${props => props.theme.radius(1)};
    }
  }
  
  &.MenuDrawer-temporary {
    &:not(.MenuDrawer-open) {
      visibility: hidden;

      > .MuiPaper-root {
        overflow: visible;
        visibility: visible;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledMenuDrawer.propTypes = {
};

export default StyledMenuDrawer;
